/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Agent_Unattended_Destructive_Writes_Enabled_DescInputs */



/**
* | output |
* | --- |
* | "Agents marked for it may now take actions oneAI recognises as irreversible without human approval. A call that also contains ordinary external writes, such a..." |
*
* @param {Audit_Details_Agent_Unattended_Destructive_Writes_Enabled_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_agent_unattended_destructive_writes_enabled_desc = /** @type {((inputs?: Audit_Details_Agent_Unattended_Destructive_Writes_Enabled_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Agent_Unattended_Destructive_Writes_Enabled_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dafür markierte Agenten dürfen jetzt Aktionen, die oneAI als unumkehrbar erkennt, ohne menschliche Genehmigung ausführen. Ein Aufruf, der zusätzlich gewöhnliche externe Schreibvorgänge enthält, etwa ein API-Stapel aus einem POST und einem DELETE, braucht zusätzlich die Einstellung für externe Schreibvorgänge.")
	return /** @type {LocalizedString} */ ("Agents marked for it may now take actions oneAI recognises as irreversible without human approval. A call that also contains ordinary external writes, such as an API batch mixing a POST with a DELETE, also needs the external-writes setting.")
});